import { useState } from "react";


import Image from "./Image.jsx";

const Breadcrumb = ({ id, booth ,category}) => {
  const [prevCategory, setPrevCategory] = useState([]);

  return (
    <>
      <div className="flex items-center my-5 justify-between  md:h-12 h-10 bg-[#EBEBEB] border-[#cbcbcb] border-solid border-[1px] rounded-full">
        <div className="flex items-center gap-5">
          <div className="flex hover:bg-blue-700 hover:transition-colors cursor-pointer md:h-12 h-10 items-center gap-2 md:px-5 pl-2  py-2  bg-[#3C74D1] rounded-full">
            <Image
              id={booth?.logo}
              className="md:w-10 w-6 rounded-full"
              alt="product1"
              size={undefined}
              width={undefined}
              height={undefined}
              defualtWidth={undefined}
            />
            <span className="text-[#fff] text-base">{booth?.title}</span>
          </div>
          <div className="md:flex hidden gap-2">
            <div className=" text-blue-900 md:text-sm text-xs  hover:text-[#FF3400] cursor-pointer">
              {category?.title}
            </div>
            {prevCategory?.map((item, index) => (
              <div
                className=" text-blue-900 md:text-sm text-xs  hover:text-[#FF3400] cursor-pointer"
                key={index}
              >
                {`>`} {item?.title}
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-4 cursor-pointer">
          {booth?.socialAddress3 && (
            <a href={booth?.socialAddress3} target="_blank" rel="noreferrer">
              {" "}
              <img
                className="w-5 hover:scale-90 ease-in duration-75"
                src="/images/icons/fabookgray.svg"
                alt="FaceBook"
              />
            </a>
          )}
          {booth?.socialAddress1 && (
            <a href={booth?.socialAddress1} target="_blank" rel="noreferrer">
              {" "}
              <img
                className="w-5 hover:scale-90 ease-in duration-75"
                src="/images/icons/whatsAppGray.svg"
                alt="WhatsApp"
              />
            </a>
          )}
        </div>
      </div>
      <div className="md:hidden overflow-x-auto">
        <div className=" flex gap-2 min-w-max">
          <div className=" text-blue-900 md:text-sm text-xs  hover:text-[#FF3400] cursor-pointer">
            home
          </div>
          {prevCategory?.map((item, index) => (
            <div
              className=" text-blue-900 md:text-sm text-xs  hover:text-[#FF3400] cursor-pointer"
              key={index}
            >
              {`>`} {item?.title}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
